import React from 'react'
import Listing from './listing/Listing'

const EmployeeRequest = () => {
  return (
    <div className='py-5 px-9'>
      <Listing />
    </div>
  )
}

export default EmployeeRequest